import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import CreatableSelectField from 'CommonComponents/CreatableSelectField';
import ModalFooter from 'CommonComponents/ModalFooter';
import TextFormField from 'CommonComponents/TextFormField';

const SportOfficialsCreateSchema = Yup.object().shape({
    firstName: Yup.string(),
    lastName: Yup.string(),
    nationality: Yup.string(),
    gender: Yup.string(),
    role: Yup.string().matches(/(TD|ITO|NTO)/),
    roleDescription: Yup.string(),
});

const genders = [
    { value: '', label: $t('Undisclosed') },
    { value: 'Male', label: $t('Male') },
    { value: 'Female', label: $t('Female') },
];

export default function SportOfficialsCreateForm(props) {
    return (
        <Formik
            initialValues={{
                firstName: '',
                lastName: '',
                nationality: '',
                gender: '',
                role: props.officialRole,
                roleDescription: '',
            }}
            validationSchema={SportOfficialsCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .post(props.sportOfficialsStoreUrl, {
                        first_name: values.firstName,
                        last_name: values.lastName,
                        nationality: values.nationality,
                        gender: values.gender,
                        role: values.role,
                        role_description: values.roleDescription,
                    })
                    .then((response) => {
                        props.setSportOfficialIsUpdated(true);
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                        actions.resetForm();
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('First Name')} type="text" name="firstName" placeholder={$t('First Name')}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Last Name')} type="text" name="lastName" placeholder={$t('Last Name')}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor="nationality" className="text-input__label">
                                {$t('Nationality')}
                            </label>
                            <CreatableSelectField
                                options={props.nationalities}
                                value={values.nationality}
                                onChange={(value) => setFieldValue('nationality', value.value)}
                            />
                            {errors.nationality && touched.nationality ? <div className="tw-text-red-500 tw-text-sm">{errors.nationality}</div> : null}
                        </div>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor="gender" className="text-input__label">
                                Gender
                            </label>
                            <CreatableSelectField options={genders} value={values.gender} onChange={(value) => setFieldValue('gender', value.value)} />
                            {errors.gender && touched.gender ? <div className="tw-text-red-500 tw-text-sm">{errors.gender}</div> : null}
                        </div>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Role')} type="text" name="role" placeholder={$t('Role')} disabled={true}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Role Description')} type="text" name="roleDescription" placeholder={$t('Role Description')}></TextFormField>
                    </div>

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Save')}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
